import { Link } from "react-router-dom";
import { Download } from "lucide-react";

export const AppFooter = ({ className = "" }) => {
  const requestInstall = () => {
    window.dispatchEvent(new Event("ask-jonny-install-request"));
  };

  return (
    <footer
      className={`flex h-9 shrink-0 items-center justify-center gap-4 border-t bg-background px-4 ${className}`}
      data-testid="app-footer"
    >
      <Link
        className="text-xs text-muted-foreground transition-colors hover:text-primary hover:underline"
        to="/privacy"
        data-testid="footer-privacy-link"
      >
        Privacy policy
      </Link>
      <Link
        className="text-xs text-muted-foreground transition-colors hover:text-primary hover:underline"
        to="/faq"
        data-testid="footer-faq-link"
      >
        FAQ
      </Link>
      <button
        type="button"
        className="flex items-center gap-1 text-xs text-muted-foreground transition-colors hover:text-primary hover:underline lg:hidden"
        onClick={requestInstall}
        data-testid="footer-install-link"
      >
        <Download className="h-3.5 w-3.5" />
        Install
      </button>
    </footer>
  );
};